import { useState, useEffect, useCallback } from 'react';
import { getPendingCount, flushQueue } from '../services/backgroundSync';

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingSyncs, setPendingSyncs] = useState(0);
  const [justSynced, setJustSynced] = useState(false);

  // Check pending queue count
  const refreshPending = useCallback(async () => {
    const count = await getPendingCount();
    setPendingSyncs(count);
  }, []);

  useEffect(() => {
    const handleOnline = async () => {
      setIsOnline(true);
      // Auto-flush queue when back online
      const synced = await flushQueue();
      if (synced > 0) {
        setJustSynced(true);
        setTimeout(() => setJustSynced(false), 3000);
      }
      refreshPending();
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    // Listen for service worker sync completions
    const handleSWMessage = (event) => {
      if (event.data?.type === 'SYNC_COMPLETE') {
        refreshPending();
        setJustSynced(true);
        setTimeout(() => setJustSynced(false), 3000);
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    navigator.serviceWorker?.addEventListener('message', handleSWMessage);

    // Initial check
    refreshPending();

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      navigator.serviceWorker?.removeEventListener('message', handleSWMessage);
    };
  }, [refreshPending]);

  return { isOnline, pendingSyncs, justSynced, refreshPending };
};
